import {Injectable} from '@angular/core';
import {PostLoginLoanApplicationFlowStep} from './post-login-loan-application-flow.step';
import {LivelihoodInformationInteractor} from '../../interactors/livelihood-information.interactor';
import {LoanApplicationInteractor} from '../../interactors/loan-application.interactor';
import {UserInteractor} from '../../interactors/user.interactor';

@Injectable()
export class LivelihoodInformationStep extends PostLoginLoanApplicationFlowStep {
    constructor(userInteractor: UserInteractor,
                private livelihoodInformationInteractor: LivelihoodInformationInteractor,
                private loanApplicationInteractor: LoanApplicationInteractor) {
        super(userInteractor);
    }

    description(): string {
        return 'To give you a fair evaluation';
    }

    displayName(): string {
        return 'About your work';
    }

    async isStepComplete(): Promise<boolean> {
        const application = await this.loanApplicationInteractor.get();
        return application ? !!await this.livelihoodInformationInteractor.getByLoanApplicationId(application.id) : false;
    }

    url(): string {
        return this.createBorrowerFlowUrl('livelihood-information');
    }
}
